import { render, staticRenderFns } from "./RsaValutazioneIngressoModalEditComponent.vue?vue&type=template&id=17248a6d"
import script from "./RsaValutazioneIngressoModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaValutazioneIngressoModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports